export const COL_TYPE = {
  LABEL_COLUMN: "LABEL_COLUMN",
  LADDER_COLUMN: "LADDER_COLUMN",
  BAND_COLUMN: "BAND_COLUMN",
};

export const CELL_TYPE = {
  LABEL_CELL: "LABEL_CELL",
  GEL_PATH: "GEL_PATH",
  TRASH_LABEL: "TRASH_LABEL",
  GEL_HOLDER: "GEL_HOLDER",
  TRASH_CAN: "TRASH_CAN",
};

export const GEL_TYPE = {
  LABEL: "LABEL",
  FIXED: "FIXED",
  DRAGGABLE: "DRAGGABLE",
};

export const GEL_DRAG_DROP = {
  GEL_ID: "GEL_ID",
  CELL_ID: "CELL_ID",
  COL_ID: "COL_ID",
};

export const MIN_TRASH_HEIGHT = 40;

export const INITIAL_STATE = {
  gelPathHeight: 1,
  gelPathPadding: 1,
  gelHolderBoxHeight: 1,
  trashRowHeight: 1,
  rangeTop: 1,
  rangeBottom: 1,
  logBase: 10,
};

export const GEL_PATH_MIN_HEIGHT = 0;

export const THEME = {
  DARK: "DARK",
  LIGHT: "LIGHT",
};
